module.exports = __webpack_public_path__ + "static/media/L1.fcf64a3f.png";